import * as React from 'react'
import { useState } from 'react'
import { connect } from 'react-redux'
import Modal from '../../common/modal'
import LineInput from '../../common/lineinput'
import { Stack, Box, Radio } from '@mui/material'
import Button from '@mui/material/Button'
import { updateModal, updateModifyRowData } from '../../../store/common/common_action'
import { WtVlmKeyArr, WtVlmUnitArr, Length, Width, Height } from '../../common/constants'
import { rate } from '../../common/bookingElementId'
import { floatFilter, focusElemnt, navigation1 } from '../../common/helper'
import LineInputV2 from '../../common/lineinputV2'
import { STA_COMPANY_ID } from '../../../helper/companyIdhardcode'
import { useSetAtom } from 'jotai'
import { updateConsignmentRowFieldAtom } from '../../common/jotaiState/bookingStateAtoms'
import { useTranslation } from '../../../i18n/I18nProvider'
import { useEffect } from 'react'

const VolumetricWeightUI = (props) => {
  const { translations } = useTranslation()
  const bs = translations?.booking || {}
  const cs = translations?.common || {}
  const {  updateModifyRowData, selectedRowIndex, slctdRwData, setSlctdRwData, calNupdateWtCharge } = { ...props }
  const {
    data: { common = {} },
  } = props
  const { loginData = {} } = common
  const { intCompanyID = 0 } = loginData
  const { unitType } = slctdRwData
  const volumetricLabelMap = {
    [Length]: cs.length || Length,
    [Width]: cs.width || Width,
    [Height]: cs.height || Height,
  }
  let volumetric = JSON.parse(JSON.stringify(WtVlmUnitArr))
  let defaultDiv = volumetric[0].devisor
  if (intCompanyID === STA_COMPANY_ID) {
    [volumetric[0], volumetric[1]] = [volumetric[1], volumetric[0]]
    defaultDiv = volumetric[0].devisor2
  }
  const [volumeDiviser, setVolumeDevisor] = useState(defaultDiv)

  const name = `vlmtrcWtRadioBtn_${selectedRowIndex}`
  const updateField = useSetAtom(updateConsignmentRowFieldAtom)
  const updateConsignmentData = (index, key, value) => {
    updateField({ index, key, value })
  }
  const handleChange = (event, devisor) => {
    setSlctdRwData({ ...slctdRwData, unitType: event.target.value })
    updateConsignmentData(selectedRowIndex, 'unitType', event.target.value)
    setVolumeDevisor(devisor)
  }

  const totalWt = () => {
    const {wt_vlm_len,wt_vlm_wid,wt_vlm_ht,unitType}=slctdRwData
    const length = Number(wt_vlm_len) || 0
    const width = Number(wt_vlm_wid) || 0
    const height = Number(wt_vlm_ht) || 0
    const volume = length * width * height;
    let totalWt=0;
    const unitData = volumetric.find(item => item.unitLabel === unitType);
    if(unitData){
      if([STA_COMPANY_ID].includes(intCompanyID)){
        totalWt =volume / unitData.devisor2
      }else{
        totalWt =volume / unitData.devisor
      }
      return totalWt.toFixed(2)
    }else{
      return 0;
    }    
  }
  const handleVlmtrcWtUnit = (e, key) => {
    if (e.target.value.match(/^\d*\.?\d*$/)) {
      setSlctdRwData({ ...slctdRwData, [key]: +e.target.value })
      updateConsignmentData(selectedRowIndex, key, +e.target.value)
    }
  }
  const resetWtVlmData = () => {
    setSlctdRwData({
      wt_vlm_len: '0',
      wt_vlm_wid: '0',
      wt_vlm_ht: '0',
      unitType: 'MM',
    })
  }
  useEffect(() => {
    focusElemnt('wt_vlm_len')
  }, [])
  return (
    <Modal
      headTxt={bs.volumetricWeightCft}
      width={'30%'}
      updateModal={() => {
        props.callFromAdmin ? props.setVolumetriModal(false) : props.updateModal()
      }}
      //updateModal={props.callFromAdmin ? props.setVolumetriModal(false) : props.updateModal}
    >
      <Stack direction="column" sx={{ padding: '15px' }}>
        <div
          style={{
            width: '100%',
            marginBottom: '30px',
            position: 'relative',
          }}
        >
          <div className={'input--wrapper'} style={{ borderBottom: `1px solid #ddd` }}>
            <span>{`${cs.unit || 'Unit'}:`}</span>
            {volumetric.map((value, ind) => (
              <span key={`vlmtrc_rad_${ind}_${window.generate_randow_token(2)}`}>
                <Radio
                  checked={unitType === value.unitLabel}
                  onChange={(e) => handleChange(e, [406, 1].includes(intCompanyID) ? value.devisor2 : value.devisor)}
                  value={value.unitLabel}
                  name={name}
                  size={'medium'}
                />
                {value.unitLabel}
              </span>
            ))}
          </div>
          <div
            style={{
              display: `flex`,
              flexWrap: `wrap`,
              justifyContent: 'space-between',
            }}
            ref={props?.inputRef}
          >
            {WtVlmKeyArr.map(({ id, lbl, nextID, prevID }, ind) => {
              if(ind===0){
                prevID='idForWeightActual'+selectedRowIndex
              }
              return (
                <Box
                  key={`vlmtrc_unit_lnIp_${id}_`}
                  sx={{
                    width: '49.5%',
                    display: 'inline-flex',
                    padding: '0% 0px',
                  }}
                >
                  <div className={'input--wrapper small_space'} style={{ width: '100%' }}>
                    <LineInputV2
                      id={id}
                      type={`text`}
                      name={id}
                      label={volumetricLabelMap[lbl] || lbl}
                      value={slctdRwData[id]}
                      filter={(v) => floatFilter(v, 2)}
                      onBlur={(e) => {
                        handleVlmtrcWtUnit(e, id)
                      }}
                      onKeyDown={(e) => {
                        if (e.key === 'Escape' && lbl == Length) {
                          props.callFromAdmin ? props.setVolumetriModal(false) : props.updateModal()
                        }
                        navigation1(e, nextID, prevID)
                      }}
                    />
                  </div>
                </Box>
              )
            })}
            <div style={{ width: '49.5%' }} key={`vlmtrc_unit_wt_${window.generate_randow_token(2)}`} className={'input--wrapper'}>
              <LineInput
                type={`text`}
                name={`vlmtrc_unit_wt`}
                label={bs.volumetricWeightKg || 'Volumetric Weight (KG)'}
                value={totalWt()}
                onChange={() => {}}
                disabled
              />
            </div>
          </div>
          <div style={{ fontSize: '12px', color: `#444` }}>
            {(bs.volumetricWeightFormulaNote || 'Note: Volumetric Weight (KG)= (Length*Width*Height/{volumeDiviser})').replace(
              '{volumeDiviser}',
              volumeDiviser
            )}
          </div>
        </div>
        <Box sx={{ width: '100%', margin: '12px 0px' }}>
          <Button
            variant="contained"
            id="saveVolumetricvol"
            onClick={(e) => {
              if (props?.callFromAdmin) {
                updateModifyRowData(selectedRowIndex, {
                  ...slctdRwData,
                  Volume: totalWt(),
                  ActualWeight: totalWt(),
                })
                calNupdateWtCharge({ ...slctdRwData, ActualWeight: totalWt() }, selectedRowIndex)
                resetWtVlmData()
                focusElemnt(rate + selectedRowIndex)
                props.setVolumetriModal(false)
              } else {
                updateConsignmentData(selectedRowIndex, 'wt_volume', totalWt())
                updateConsignmentData(selectedRowIndex, 'wt_vlm_len', slctdRwData?.wt_vlm_len)
                updateConsignmentData(selectedRowIndex, 'wt_vlm_wid', slctdRwData?.wt_vlm_wid)
                updateConsignmentData(selectedRowIndex, 'wt_vlm_ht', slctdRwData?.wt_vlm_ht)
                updateConsignmentData(selectedRowIndex, 'weightType', 1)

                calNupdateWtCharge({ ...slctdRwData, wt_volume: totalWt() }, selectedRowIndex)
                resetWtVlmData()
                focusElemnt(rate + selectedRowIndex)
                props.updateModal()
              }
            }}
            className="btn btn-primary"
            sx={{
              width: '100%',
              padding: '10px',
              letterSpacing: '2px',
            }}
          >
            {cs.save || 'SAVE'}
          </Button>
        </Box>
      </Stack>
    </Modal>
  )
}
const mapStateToProps = (data) => ({ data })

const mapDispatchToProps = { updateModal, updateModifyRowData }
export default connect(mapStateToProps, mapDispatchToProps)(VolumetricWeightUI)
